import { Timeout } from "../../common/Timeout";
import { Action } from "../createDataContext";

export interface CombinationRange {
  max: number;
  min: number;
}

export enum SuggestionResult {
  FOUND = "FOUND",
  EXCEPTION_FOUND = "EXCEPTION_FOUND",
  NOT_FOUND = "NOT_FOUND",
  IN_PROGRESS = "IN_PROGRESS",
  RESTORE = "RESTORE",
}

export interface Condition {
  humidity: number[];
  temperature: number[];
}

export interface Suggestable {
  location: number;
  ageGroup: number[];
  sweatComment: number[];
  conditions: Condition;
}

export interface Combination extends Suggestable {
  combinationID: number;
  layers: number[][];
  wikiID: number;
  addToCartLink: AddToCartLink;
}

export interface AddToCartLink {
  ["hu"]: string | null;
  ["en"]: string | null;
}

export interface CombinationException extends Suggestable {
  exceptionID: number;
  exceptionResponseKey: string;
}

export class SuggestionState {
  ageGroup: number;
  result: SuggestionResult;
  suggestions: CombinationSuggestion[] | null;
  sweatComment: number;
  exception?: CombinationException;
  timeoutRef?: Timeout;

  constructor(
    result: SuggestionResult,
    ageGroup: number,
    sweatComment: number,
    suggestions: CombinationSuggestion[] | null,
    exception?: CombinationException,
    timeoutRef?: Timeout
  ) {
    this.ageGroup = ageGroup;
    this.result = result;
    this.suggestions = suggestions;
    this.sweatComment = sweatComment;
    this.exception = exception;
    this.timeoutRef = timeoutRef;
  }
}

export class RoundedConditions {
  humidity: number;
  temp: number;

  constructor(temp: number, humidity: number) {
    this.humidity = Math.round(humidity);
    this.temp = Math.round(temp);
  }
}

export class CombinationSuggestion {
  combinationID: number;
  layers: number[][];
  wikiID: number | null;
  addToCartLink: AddToCartLink;

  constructor(
    combinationID: number,
    layers: number[][],
    wikiID: number,
    addToCartLink: AddToCartLink
  ) {
    this.combinationID = combinationID;
    this.layers = layers;
    this.wikiID = wikiID;
    this.addToCartLink = addToCartLink;
  }
}

export interface SuggestionFoundAction extends Action {
  type: SuggestionResult.FOUND;
  payload: {
    suggestions: CombinationSuggestion[];
  };
}

export interface ExceptionFoundAction extends Action {
  type: SuggestionResult.EXCEPTION_FOUND;
  payload: {
    exception: CombinationException;
  };
}

export interface SuggestionNotFoundAction extends Action {
  type: SuggestionResult.NOT_FOUND;
}

export interface SuggestionInProgressAction extends Action {
  type: SuggestionResult.IN_PROGRESS;
  payload: {
    timeoutRef: Timeout;
  };
}

export interface SuggestionsRestoreAction extends Action {
  type: SuggestionResult.RESTORE;
  payload: null;
}

export type SuggestionActions =
  | SuggestionFoundAction
  | ExceptionFoundAction
  | SuggestionNotFoundAction
  | SuggestionInProgressAction
  | SuggestionsRestoreAction;
